import { render, staticRenderFns } from "./UserCreateOrderService.vue?vue&type=template&id=5bd5de15&scoped=true&"
import script from "./UserCreateOrderService.vue?vue&type=script&lang=js&"
export * from "./UserCreateOrderService.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateOrderService.vue?vue&type=style&index=0&id=5bd5de15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5de15",
  null
  
)

export default component.exports